import React from 'react';
import '../../styles/shared/_slider-investments.scss';

const SliderEmprendimientos = () => {
	return (
		<section className='slider-investments'>
			{/* item */}
			<div className='item'>
				<div
					className='welcome__card'
					style={{
						backgroundImage: `url(../images/alvear.jpg)`
					}}
					data-aos='zoom-in'
					data-aos-delay='0'
				>
					<a
						href={`https://peraltajuarez.com.ar/qr/alvear.pdf`}
						target='_blank'
						rel='noopener noreferrer'
					>
						<div className='welcome__card-button'>
							{/* <button className='btn text-uppercase'> </button> */}
						</div>
					</a>
				</div>
			</div>
			{/* item */}
			<div className='item'>
				<div
					className='welcome__card'
					style={{
						backgroundImage: `url(../images/img-terraza-cortes.jpeg)`
					}}
					data-aos='zoom-in'
					data-aos-delay='0'
				>
					<a
						href={`https://peraltajuarez.com.ar/qr/terraza-cortes.pdf`}
						target='_blank'
						rel='noopener noreferrer'
					>
						<div className='welcome__card-button'>
							{/* <button className='btn text-uppercase'> </button> */}
						</div>
					</a>
				</div>
			</div>
			{/* item */}
			<div className='item'>
				<div
					className='welcome__card'
					style={{
						backgroundImage: `url(../images/duplex-francia.jpeg)`
					}}
					data-aos='zoom-in'
					data-aos-delay='0'
				>
					<a
						href={`https://peraltajuarez.com.ar/qr/duplex-francia.pdf`}
						target='_blank'
						rel='noopener noreferrer'
					>
						<div className='welcome__card-button'>
							{/* <button className='btn text-uppercase'>  </button> */}
						</div>
					</a>
				</div>
			</div>
			{/* item */}
			<div className='item'>
				<div
					className='welcome__card'
					style={{
						backgroundImage: `url(../images/la-brava.jpeg)`
					}}
					data-aos='zoom-in'
					data-aos-delay='0'
				>
					<a
						href={`https://labravabarrio.com.ar/`}
						target='_blank'
						rel='noopener noreferrer'
					>
						<div className='welcome__card-button'>
							{/* <button className='btn text-uppercase'> Duplex Francia </button> */}
						</div>
					</a>
				</div>
			</div>
			{/* item */}
			<div className='item'>
				<div
					className='welcome__card'
					style={{
						backgroundImage: `url(../images/edificio-troche.jpeg)`
					}}
					data-aos='zoom-in'
					data-aos-delay='0'
				>
					<a
						href={`https://peraltajuarez.com.ar/qr/troche.pdf`}
						target='_blank'
						rel='noopener noreferrer'
					>
						<div className='welcome__card-button'>
							{/* <button className='btn text-uppercase'> Duplex Francia </button> */}
						</div>
					</a>
				</div>
			</div>
			{/* item */}
		</section>
	);
};

export default SliderEmprendimientos;
